// extracted by mini-css-extract-plugin
export default {"container":"CustomCircle_container__WMFSh","svg":"CustomCircle_svg__849dZ","info":"CustomCircle_info__MT-vS"};